const state = {
  dynamicBreadcrumb: {},
};

const getters = {
  dynamicBreadcrumb() {
    return state.dynamicBreadcrumb;
  },
};

const actions = {};

const mutations = {
  setDynamicBreadcrumb(state, data) {
    state.dynamicBreadcrumb = Object.assign({}, state.dynamicBreadcrumb, {
      [data.key]: data,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
